// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const PinIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "Pin/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.514 3.378a.558.558 0 0 0 .555-.558v-.13a.69.69 0 0 0-.692-.69l-8.344.042a.67.67 0 0 0-.665.696l.004.101c.012.302.26.541.563.541.33 0 .589.282.561.61l-.747 8.956a.88.88 0 0 1-.874.806l-.19.001a.686.686 0 0 0 0 1.372l4.854.009-.004 6.174a.692.692 0 1 0 1.383 0v-6.174l4.85-.009a.688.688 0 0 0 0-1.375h-.187a.876.876 0 0 1-.872-.803l-.748-8.965a.558.558 0 0 1 .553-.604Zm-1.222 9.22a1.064 1.064 0 0 1-1.06 1.152h-4.006a1.064 1.064 0 0 1-1.06-1.151l.68-8.252a1.064 1.064 0 0 1 1.06-.977h2.646c.553 0 1.015.425 1.06.977l.68 8.252Z"
}));
export default PinIcon;